import { render, staticRenderFns } from "./ver_responder_proyecto2.vue?vue&type=template&id=08486720"
import script from "./ver_responder_proyecto2.vue?vue&type=script&lang=js"
export * from "./ver_responder_proyecto2.vue?vue&type=script&lang=js"
import style0 from "./ver_responder_proyecto2.vue?vue&type=style&index=0&id=08486720&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports